import { DeskBookings } from "./DeskBookings";
import { LocationBookings } from "./LocationBookings";

export class Bookings {
  constructor(
    public readonly deskBookings: DeskBookings,
    public readonly locationBookings: LocationBookings
  ) {}
}
